import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  footerData: null,
};

export const getFooter = createAsyncThunk(
  "footer/getFooter",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`site/footer`,{params});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);

    }
  }
);

const footerSlice = createSlice({
  name: "footer",
  initialState,
  reducers: {},
  extraReducers: {
    [getFooter.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getFooter.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.footerData = action.payload?.data;
    },
    [getFooter.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default footerSlice.reducer;
